import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { QUICKSTART_PANEL_VISIBILITY_STATE_KEY, type QuickstartUiStatus } from '../constants.tsx';

export const performSaveQuickstartBannerVisibility = async (
	accountId: AccountId,
	visibility: QuickstartUiStatus,
): Promise<void> => {
	await setUserProperties(
		accountId,
		QUICKSTART_PANEL_VISIBILITY_STATE_KEY,
		JSON.stringify(visibility.description),
	);
};
